module.exports = __webpack_public_path__ + "img/icon8.5a9cc0e8.svg";